import { render } from "./ShoppingCartStepOneTableColumn.vue?vue&type=template&id=2fbb426d&scoped=true"
import script from "./ShoppingCartStepOneTableColumn.vue?vue&type=script&lang=js"
export * from "./ShoppingCartStepOneTableColumn.vue?vue&type=script&lang=js"

import "./ShoppingCartStepOneTableColumn.vue?vue&type=style&index=0&id=2fbb426d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fbb426d"

export default script